var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isPC)?_c('Home'):_c('div',{staticClass:"inpc"},[_c('div',{staticClass:"pc-wrapper",style:(_vm.inPcStyle)},[_c('Home')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }